import type { FetchTicketResponse } from "src/api/models";
import type { Column } from "src/types/trello-board-type";
import type { MenuItem } from "../types";
import { combineDateWithTime, toLocalDateString } from "src/utils/date-utc";

export function createCutMenuItem(
  ticket: FetchTicketResponse,
  cutTicket: FetchTicketResponse | null,
  handlers: {
    onCut: (ticket: FetchTicketResponse) => void;
  }
): MenuItem {
  return {
    label: "Cut ticket",
    icon: "pi pi-cut",
    disabled: ticket.id === cutTicket?.id,
    command: () => handlers.onCut(ticket)
  };
}

export function createPasteMenuItem(
  column: Column<FetchTicketResponse>,
  cutTicket: FetchTicketResponse | null,
  handlers: {
    updateTicketPlannedDate: (ticketId: string, date: string) => Promise<void>;
    onPaste: (ticket: FetchTicketResponse, column: Column<FetchTicketResponse>) => void;
    showError: (options: { message: string }) => void;
  }
): MenuItem {
  return {
    label: "Paste ticket",
    icon: "pi pi-paste",
    disabled: !cutTicket,
    command: () => {
      if (!cutTicket) return;
      const newDateStr = toLocalDateString(column.date);
      const newScheduledDate = combineDateWithTime(newDateStr, cutTicket.scheduled_date);
      const updatedTicket = {
        ...cutTicket,
        scheduled_date: newScheduledDate
      };

      handlers.updateTicketPlannedDate(cutTicket.id, newScheduledDate)
        .then(() => handlers.onPaste(updatedTicket, column))
        .catch(() => handlers.showError({ message: "Failed to reschedule ticket" }));
    }
  };
}
